var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _circle, _path17, _rect2, _circle2, _path18, _rect3, _circle3, _path19, _rect4, _circle4, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlottingPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 57,
    viewBox: "0 -30 171 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 52.8145H63.6328V56.3728H170.187V52.8145Z",
    fill: "#EDECEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 52.6826H64.2168V55.4502H170.771V52.6826Z",
    fill: "#F9F6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 50.5742H63.6328V54.1324H170.187V50.5742Z",
    fill: "#EDECEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 50.5742H64.2168V53.3418H170.771V50.5742Z",
    fill: "#F9F6F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 48.334H63.6328V51.8923H170.187V48.334Z",
    fill: "#EDECEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 48.334H64.2168V51.1016H170.771V48.334Z",
    fill: "#F9F6F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 46.0933H63.6328V49.6516H170.187V46.0933Z",
    fill: "#EDECEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 46.0933H64.2168V48.8608H170.771V46.0933Z",
    fill: "#F9F6F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 43.5894H63.6328V47.1477H170.187V43.5894Z",
    fill: "#EDECEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 43.5894H64.2168V46.3569H170.771V43.5894Z",
    fill: "#F9F6F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 41.3491H63.6328V44.9074H170.187V41.3491Z",
    fill: "#EDECEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 41.3491H64.2168V44.1167H170.771V41.3491Z",
    fill: "#F9F6F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 39.2402H63.6328V42.7985H170.187V39.2402Z",
    fill: "#EDECEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 39.1084H64.2168V41.8759H170.771V39.1084Z",
    fill: "#F9F6F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.187 37H63.6328V40.5583H170.187V37Z",
    fill: "#EDECEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M170.771 37H64.2168V39.7676H170.771V37Z",
    fill: "#F9F6F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 12.5,
    stroke: "#B2B2B2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8877 49L19.3597 39.48H20.6337L24.1057 49H22.7617L21.8937 46.564H18.0577L17.1897 49H15.8877ZM18.4637 45.416H21.4877L19.9757 41.09L18.4637 45.416Z",
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 40,
    height: 56,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 19,
    r: 12.5,
    stroke: "#B2B2B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8105 49V39.48H60.4925C62.5365 39.48 63.5165 40.25 63.5165 41.944C63.5165 43.008 63.1385 43.68 62.2705 44.002V44.03C63.3625 44.366 63.8385 45.108 63.8385 46.368C63.8385 48.16 62.8725 49 60.7725 49H56.8105ZM58.0705 43.568H60.4085C61.7385 43.568 62.2705 43.162 62.2705 42.112C62.2705 41.048 61.7245 40.628 60.3945 40.628H58.0705V43.568ZM58.0705 47.852H60.5905C62.0185 47.852 62.5785 47.39 62.5785 46.284C62.5785 45.15 61.9905 44.716 60.4365 44.716H58.0705V47.852Z",
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 40,
    height: 56,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 19,
    r: 12.5,
    stroke: "#B2B2B2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 49.168C97.7442 49.168 96.5822 47.908 96.5822 45.402V43.078C96.5822 40.572 97.7442 39.312 100.138 39.312C102.378 39.312 103.526 40.404 103.61 42.616H102.378C102.308 41.146 101.594 40.46 100.138 40.46C98.5422 40.46 97.8422 41.272 97.8422 43.106V45.374C97.8422 47.208 98.5422 48.02 100.138 48.02C101.594 48.02 102.308 47.334 102.378 45.878H103.61C103.526 48.076 102.378 49.168 100.138 49.168Z",
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 40,
    height: 56,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 19,
    r: 12.5,
    stroke: "#B2B2B2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M136.763 49V39.48H140.039C142.531 39.48 143.651 40.642 143.651 43.176V45.304C143.651 47.838 142.531 49 140.039 49H136.763ZM138.023 47.852H139.885C141.677 47.852 142.391 47.124 142.391 45.29V43.19C142.391 41.356 141.677 40.628 139.885 40.628H138.023V47.852Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlottingPaper);
export default __webpack_public_path__ + "static/media/Blotting_Paper.5ad4ce0fe4824e81309a3f62f4219f5c.svg";
export { ForwardRef as ReactComponent };